import constant from "../_config/constant";
import { handleResponse } from "../_helpers/utils";
import {
  authHeader,
  // logout,
  basicAuthHeader,
} from "../_helpers";

const getCardList = async () => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
    return fetch(`${constant.apiUrl}/card`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

const addNewCard = async (data) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
    return fetch(`${constant.apiUrl}/card`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

const deleteCard = async (id) => {
  const requestOptions = {
    method: "DELETE",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify({id}),
  };
    return fetch(`${constant.apiUrl}/card/${id}`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}


//
const makeCardPrimary = async (id, fromBooking) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify({ cardId: id, fromBooking }),
  };
    return fetch(`${constant.apiUrl}/card/primary`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

export const bankService = {
  addBank,
  verifyBank,
  deleteBank,
  updateBank,
  bankList,
  makePrimary,
  getStripeDetail,
  getStripeLinkUrl,
  getStripeLoginLinkUrl,
  getStripeSession,

  addNewCard,
  deleteCard,
  makeCardPrimary,
  getCardList,
  sourcesList,
};

// Stripe 


function getStripeSession() {
  console.log("here")
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(`${constant.apiUrl}/stripe-account-create`, requestOptions)
    .then(handleResponse)
    .then((details) => {
      console.log("here2");
      return details;
    });
}

// Stripe

function getStripeDetail() {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(`${constant.apiUrl}/stripe/account`, requestOptions)
    .then(handleResponse)
    .then((details) => {
      return details;
    });
}

function getStripeLinkUrl() {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(`${constant.apiUrl}/stripe/linkAccount`, requestOptions)
    .then(handleResponse)
    .then((details) => {
      return details;
    });
}

function getStripeLoginLinkUrl() {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(`${constant.apiUrl}/stripe/loginLink`, requestOptions)
    .then(handleResponse)
    .then((details) => {
      return details;
    });
}

function sourcesList() {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(`${constant.apiUrl}/subscription/sources`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function bankList() {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(`${constant.apiUrl}/bank/list`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function addBank(data) {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  return fetch(`${constant.apiUrl}/addBank`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}
function updateBank(data) {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  return fetch(`${constant.apiUrl}/updateBank`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function deleteBank(data) {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  return fetch(`${constant.apiUrl}/deleteBank`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function verifyBank(data) {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  return fetch(`${constant.apiUrl}/verifyBank`, requestOptions)
    .then(handleResponse)
    .then((user) => {
      return user;
    });
}

function makePrimary(data) {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  return fetch(`${constant.apiUrl}/bank/primary`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

